import React, { useEffect, useRef, useState } from "react";
import Space from "../ui/Space";
import Label from "../ui/Label";
import Input from "../ui/Input";
import Divider from "../ui/Divider";
import Status from "../ui/Status";
import { HelpIcon, InfoIcon, SettingsIcon } from "../utils/Icons";
import { KBD } from "../utils/Keybindings";
import { listen } from "../hooks/Listener";
import { pubCall } from "../utils/PubSub";
import { showError, showMessage } from "../ui/Message";
import CategorySelectorInput from "../ui/CategorySelectorInput";
import { ROUTES } from "../utils/Routes";
import { createModal } from "../hooks/createModal";
import { getSaved, kbdEvent, removeKey, save, showHelp, splitClassString, ucfirst } from "../utils/Utils";
import { createScreen } from "../hooks/createScreen";
import AuthorPickerScreen from "../screens/AuthorPickerScreen";
import TitleLinkSearch from "./TitleLinkSearch";
import Bisacs from "../popovers/Bisacs";
import { VALIDATE } from "../utils/Validators";
import Spin from "../ui/Spin";
import { getSignal, setSignal } from "../App";
import Float from "../ui/Float";
import Button from "../ui/Button";
import TitleLinkSettings from "./TitleLinkSettings";
import Checkbox from "../ui/Checkbox";
import ToolTip from "../ui/ToolTip";
import InventoryLabels from "./InventoryLabels";
import { drawPicker } from "../popovers/Picker";
import { getValue } from "@testing-library/user-event/dist/utils";
export default function InventorySearch(props) {

    const { controller = "", route = "", signal = {}, setSelected = () => {}, selected = false, setStock = () => { } } = props;
    const [loading, setLoading] = useState(false);

    // Overide callback to save search to cookies
    const callback = (_obj, _type, _msg = "Search Results", _term = "") => {
        save("search", removeKey(search, "isbn")); // don't save isbn
        save("search_index", index);
        props.callback({ type: _type, data: _obj, message: _msg, term: _term });
    }

    // Use saved if exists, add back the isbn.
    let _saved = getSaved("search");
    let _isbn = (!selected) ? "" : (selected.condition_code && selected.condition_code !== " ") ? selected.primary_code.slice(0, -1) + selected.condition_code : selected.primary_code;
    const [search, setSearch] = useState((_saved) ? { ..._saved, "isbn": _isbn, } : {
        keywords: "",
        isbn: _isbn,
        title: "",
        author: "",
        supplier: "",
        supplier_title: "",
        class: "",
        class_title: "",
        subject: "",
        upc: ""
    })

    // Starting position
    const [index, setIndex] = useState(getSaved("search_index") || 0);

    // Refs for arrow keys
    const refs = useRef([]);
    const numInputs = 10;

    // Auto focus the field
    useEffect(() => {
        refs.current[index].focus();
    }, [index])

    // Function to handle focusing the next element
    const next = () => {
        const current = refs.current.findIndex(ref => ref === document.activeElement || ref.element === document.activeElement);

        // if (current === 5 || current === 4) {
        //     setIndex(8);
        //     return;
        // }

        // if (current === 6 || current === 7) {
        //     setIndex(9);
        //     return;
        // }

        if (current !== -1 && current < numInputs - 1) {
            if (current === 4) {
                setIndex(6)
            } else if (current === 6) {
                setIndex(8)
            } else {
                setIndex(current + 1);
            }
        }
    };

    // Function to handle focusing the previous element
    const prev = () => {
        const current = refs.current.findIndex(ref => ref === document.activeElement || ref.element === document.activeElement);
        if (current > 0) {
            if (current === 6) {
                setIndex(4)
            } else if (current === 8) {
                setIndex(6)
            } else {
                setIndex(current - 1);
            }
        }
    };

    // Status Messages
    const status = [
        <>Enter partial keyword(s) {(!search?.keywords && <>or [ alone to choose an existing keyword tag</>)}</>,
        <>Accepts either the start of an ISBN or the full ISBN.</>,
        <>Exact start of title, then optional comma and keywords</>,
        <>Last name, First name, Keywords</>,
        <>Use the 3-digit Pubstock vendor code, or your local 3-4 digit vendor codes. Title is optional.</>,
        <></>,
        <>Press <strong>{KBD.F4.label}</strong> to select a class - Local search only</>,
        <>Local search only</>,
        <>Enter either a partial or complete BISAC code. Ex: FIC or FIC009000.</>,
        <>Search the secondary product code field, typically where UPC or vendor SKU are placed.</>
    ];

    // Pubsub calls + send results to callback
    const callSearch = (endpoint, params, type, term = "") => {

       
        if (type === "isbn" || type === "upc") {
            type = type.toUpperCase();
        }

        setLoading(true)
        pubCall(endpoint, params, (_s, _r) => {
            if (_s) {

                let searchMsg = "";

                // Only keyword searches show the count
                if (type === "keyword") {
                    searchMsg = <>Search results: <span className="text-light">{_r.total}</span> matches using <span className="text-light">{ucfirst(type)}:</span> <em className="text-yellow">'{term}'</em>.</>;
                } else {
                    searchMsg = <>Search results using <span className="text-light">{ucfirst(type)}:</span> <em className="text-yellow">'{term}'</em>.</>;
                }

                callback(_r, type, searchMsg, term)
                //callback({ type, data: _r, type, search: searchMsg  });
            } else {
                showError(_r)
            }
            setLoading(false)
        });
    };


    const searchTitleLink = (_search, _index, _enter = false, local = false) => {
      
        if (index === 8) {
            local = false;
        }

        if (index === 6 || index === 7) {
            local = true;
        }


        if (local) {
            runSearch(_search)
            return;
        } else {

            if (_enter && (_index === 3 || _index === 8)) {
                if (_index === 3) {
                    showAuthorPicker()
                    return;
                }
                if (_index === 8) {
                    showBisacPicker()
                    return;
                }
            }
        }




        let _term = "";
        let _sterm = "";
        let _type = "";
        let _supplier = "";
        let _bisac = "";

        switch (_index) {
            case 0: _type = "keyword"; _term = _search.keywords; _sterm = "Keywords"; break;
            case 1: _type = "keyword"; _term = _search.isbn; _sterm = "ISBN"; break;
            case 2: _type = "title"; _term = _search.title; _sterm = "Title"; break;
            case 3: _type = "author"; _term = _search.author; _sterm = "Author"; break;
            case 4: _type = "keyword"; _supplier = _search.supplier; _term = _search.supplier_title; _sterm = "Supplier"; break;
            case 5: _type = "keyword"; _supplier = _search.supplier; _term = _search.supplier_title; _sterm = "Supplier"; break;
            case 8: _type = "keyword"; _bisac = _search.subject; _term = _search.subject; _sterm = "Subject"; break;
            case 9: _type = "keyword"; _term = _search.upc; _sterm = "UPC"; break;
        }

        setLoading(true);
        const defaults = {
            limit: 100,
            sort: "I",
            scope: "A"
        }

        const title_link_settings = getSaved("titlelink_settings") || defaults
        let _scope = title_link_settings.scope
        _scope = (_scope === "B") ? "both" : (_scope === "I") ? "inactive" : "active";

        let _sort = title_link_settings.sort;
        _sort = (_sort === "F") ? "forthcoming" : (_sort === "R") ? "rank" : (_sort === "I") ? "in_stock" : (_sort === "P") ? "pubdate" : (_sort === "T") ? "title" : "author";

        let _limit = title_link_settings.limit;

        let _params = {
            term: _term,
            type: _type,
            scope: _scope,
            sort: _sort,
            limit: _limit
        };



        if (_supplier) { _params.supplier = _supplier }
        if (_bisac) { _params.bisac = _bisac; _params.term = "" }
        
        pubCall("title_link.search", _params, (_s, _r) => {
            if (_s) {
                _r = _r.rows.map((item, index) => {
                    let _i = (item.stock) ? { ...item.stock } : { stock_id: "no-stock" + index }
                    _i.title_link = item.title_link;
                    return _i;
                })
                let searchMsg = "";
                searchMsg = <>Search results: <span className="text-light">{_r.length}</span> matches using <span className="text-light">{ucfirst(props.sterm)}:</span> <em className="text-yellow">'{_term}'</em>.</>;
                callback(_r, "title_link", searchMsg, _term);

            } else {
                showError(_r);
            }
            setLoading(false)
        });
    }


    const searchTitle = () => { callSearch("stock.searchTitle", { limit: 45, title: search.title }, "title", search.title); };
    const searchKeyword = (_search) => { callSearch("stock.searchKeyword", { limit: 45, offset: 0, keyword: _search.keywords }, "keyword", _search.keywords); };
    const searchISBN = () => { callSearch("stock.searchIsbn", { limit: 45, isbn: search.isbn }, "isbn", search.isbn); };
    const searchSupplier = () => { callSearch("stock.searchSupplier", { limit: 45, supplier: search.supplier, title: search.supplier_title }, "supplier", (search.supplier_title) ? search.supplier + " (" + search.supplier_title + ")" : search.supplier); };
    const searchAuthor = (_stock_id, _author) => { callSearch("stock.getInitial", { limit: 45, sort: "author", stock_id: _stock_id }, "author", _author); };
    const searchClass = () => {
        const obj = splitClassString(search.class);
        let _ti = (search.class_title) ? " (" + search.class_title + ")" : "";
        callSearch("stock.searchClass", { limit: 45, class_1: obj.class_1, class_2: obj.class_2, title: search.class_title }, "class", (obj.class_2) ? obj.class_1 + "-" + obj.class_2 + _ti : obj.class_1 + _ti);
    };
    const searchUPC = () => { callSearch("stock.searchUpc", { limit: 45, upc: search.upc }, "upc", search.upc); };

    const showBisacPicker = () => {
        window.bm_state.value = ROUTES.HELPERS.BISACS;
        refs.current[index].blur();
        createModal({
            title: "Bisacs",
            component: <Bisacs controller={controller} modal value={refs.current[index].value} route={ROUTES.HELPERS.BISACS} />, closable: true, callback: (e) => {
                window.bm_state.value = route;
                if (e) {
                    setSearch({ ...search, "subject": e });
                }
                refs.current[index].focus();
            }
        })
    }


    const showSettings = () => {
        window.bm_state.value = ROUTES.HELPERS.TITLELINK_SETTINGS;
        refs.current[index].blur();
        createModal({
            title: "Titlelink Settings",
            component: <TitleLinkSettings controller={controller} route={ROUTES.HELPERS.TITLELINK_SETTINGS} />, closable: true, callback: (e) => {
                window.bm_state.value = route;
                if (e) {
                    setSearch({ ...search, "subject": e });
                }
                refs.current[index].focus();
            }
        })
    }



    const showTags = (_search = "") => {
        refs.current[index].blur();
        window.bm_state.value = ROUTES.INVENTORY.LABELS;

        pubCall("stock_tag.getTagCounts", {}, (_s, _r) => {

            const options = _r.map(item => {
                return {
                    label: <Space><div style={{"width" : "40px", "display" : "inline", "opacity" : "0.5", "textAlign" : "left", "borderRight" : "1px solid var(--border-secondary)"}}><small>{item.count}</small></div><div>{item.tag}</div></Space>,
                    value: item.tag
                }
            })
            if (_s) {
                drawPicker({
                    controller: controller,
                    showSearch: true,
                    searchValue: true,
                    value: "[", title: "Tag", closeable: true, height: 300, ref: null, route: route, close: () => { refs.current[index].focus(); }, callback: (e, f) => {
                        if (e) {
                            searchTitleLink({...search, "keywords" : e}, index, true, true)
                        }

                    }, offset: [0, 10],
                    options: options
                })
            } else {
                showError(_r);

            }
        })

    }


    // Author Picker
    const showAuthorPicker = () => {
        refs.current[index].blur();
        if (!search.author) {
            showError({ error: "Author required" })
            return;
        }
        window.bm_state.value = ROUTES.INVENTORY.AUTHORPICKER;
        createScreen({
            signal: signal,
            component: <AuthorPickerScreen controller={controller} stock_data={selected} author={search.author} route={ROUTES.INVENTORY.AUTHORPICKER} />, closable: true, title: "Select Author",
            callback: (_obj) => {
                if (_obj?.author) {
                    setSearch({ ...search, "author": _obj.author });
                    searchAuthor(_obj.title.stock_id, _obj.author)
                } else {
                    setStock(selected)
                }
                refs.current[index].focus();
                refs.current[index].select();
                window.bm_state.value = route;
            }
        });
    }

    // Run Search
    const runSearch = (_search) => {

        switch (index) {
            case 0: searchKeyword(_search); break;
            case 1: searchISBN(); break;
            case 2: searchTitle(); break;
            case 3: showAuthorPicker(); break;
            case 4: searchSupplier(); break;
            case 5: searchSupplier(); break;
            case 6: searchClass(); break;
            case 7: searchClass(); break;
            case 8: showBisacPicker(); break;
            case 9: searchUPC(); break;
        }
    }

    // Tabs for two key search
    const shiftNext = () => {
        if (index === 4) { setIndex(5); return; }
        if (index === 6) { setIndex(7); return; }

        next();
    }
    const shiftPrev = () => {
        if (index === 5) { setIndex(4); return; }
        if (index === 7) { setIndex(6); return; }
        prev();
    }

    // Keyboard Events
    useEffect(() => {


        if (loading) {
            return;
        }

        const actions = [
            { key: KBD.ARROW_DOWN, action: (e) => { next() } },
            { key: KBD.ARROW_UP, action: (e) => { prev() } },
            { key: KBD.TAB, action: (e) => { shiftNext() } },
            { key: KBD.SHIFT_TAB, action: (e) => { shiftPrev() } },
            { key: KBD.ESCAPE, action: (e) => { props.callback() } },
            {
                key: KBD.ENTER, action: (e) => {

                    if (index === 4) { setIndex(5); return; }
                    if (index === 6) { setIndex(7); return; }

                    searchTitleLink(search, index, true)
                }
            },
            {
                key: KBD.LEFT_BRACKET, action: (e) => {
                    if (index === 0 && !search?.keywords) {
                        showTags();
                    }
                }
            },
            { key: KBD.CTRL_ENTER, action: (e) => { searchTitleLink(search, index, true, true) } },
            { key: KBD.ALT_S, action: (e) => { showSettings() } },
            { key: KBD.ALT_H, action: (e) => { drawHelp() } },
            { key: KBD.PAGE_UP, action: (e) => { searchTitleLink(search, index); } },
            { key: KBD.PAGE_DOWN, action: (e) => { searchTitleLink(search, index); } },
        ];
        const cleanup = listen(controller, route, actions, false, [KBD.ARROW_DOWN, KBD.ARROW_UP, KBD.LEFT_BRACKET, KBD.TAB, KBD.SHIFT_TAB, KBD.ESCAPE, KBD.ENTER, KBD.CTRL_ENTER, KBD.PAGE_UP, KBD.PAGE_DOWN, KBD.ALT_S, KBD.ALT_H, KBD.ALT_L]);
        return cleanup;
    }, [search, index, loading]);





    const drawHelp = () => {

        showHelp({
            callback: () => { }, width: 700, route: route, title: "Help", component: <div style={{ "padding": "10px", "height": "calc(100vh - 200px)", "minHeight": "400px", "overflow": "scroll" }}>
                <Label style={{ "textAlign": "left" }}>
                    <strong style={{ "color": "var(--text-light)" }}>Product Searching Help & Tips</strong><div className="shim" /><div className="shim" />
                    For all search fields, spelling matters — there is no spell check or auto correction of misspelled search terms.<div className="shim" /><div className="shim" />
                    There is a word "autocomplete" function that activates for 4-letter words and longer. For example, searching for SAND will also return results for words that just start with SAND, such as SANDERSON. 3-letter words and less are taken exactly as is, so searching for CAT will not return results containing CATS or CATERPILLAR.<div className="shim" /><div className="shim" />
                    We recommend omitting non-essential terms like THE, AND, OF, A unless they are what makes a particular search unique.
                </Label><div className="shim" />
                <div className="shim" /><div className="shim" />

                <Label style={{ "textAlign": "left" }}>
                    <strong style={{ "color": "var(--text-light)" }}>Keywords</strong><div className="shim" /><div className="shim" />
                    This should be how 99% of your searches are done, as this will search ISBN, title, sub-title, authors, class, publisher, and inventory notes/tags. Separate search terms with a space. A great technique for pinpointing a particular title and its perhaps many editions are to include a few words from the title and the author's first or last name. If you have an ISBN to search, we still recommend using the Keywords field.
                </Label><div className="shim" />
                <div className="shim" /><div className="shim" />

                <Label style={{ "textAlign": "left" }}>
                    <strong style={{ "color": "var(--text-light)" }}>ISBN</strong><div className="shim" /><div className="shim" />
                    This "Exact Match" field is looking for an exact match, and will not return stock condition versions of products unless you specify that in the ISBN. You can also use this field to search a list of titles belonging to an ISBN prefix. This field is helpful when search for local SKU products that do not exist in Titlelink.
                </Label><div className="shim" />
                <div className="shim" /><div className="shim" />

                <Label style={{ "textAlign": "left" }}>
                    <strong style={{ "color": "var(--text-light)" }}>Title</strong><div className="shim" /><div className="shim" />
                    Looks for an exact title match. This is helpful for generically titled books that would otherwise get lost in the sea of results should you use the recommended Keywords. For example, a book's title is "The Bond". If you use that term in Keywords, you will be getting results with not only Bond in the title, but bond for the subject matter, publishers and authors with bond in their name, etc.
                </Label><div className="shim" />
                <div className="shim" /><div className="shim" />

                <Label style={{ "textAlign": "left" }}>
                    <strong style={{ "color": "var(--text-light)" }}>Author</strong><div className="shim" /><div className="shim" />
                    Looks for an exact author name match, where the text entered should follow the "last name, first name" convention. You can also simply enter a first or last name. This is helpful if the author's name is perhaps something that would also be commonly found in book titles or descriptions too, such as the word STAR.
                </Label><div className="shim" />
                <div className="shim" /><div className="shim" />

                <Label style={{ "textAlign": "left" }}>
                    <strong style={{ "color": "var(--text-light)" }}>Supplier</strong><div className="shim" /><div className="shim" />
                    Enter the 3-4 digit supplier code then leave the Title field blank to bring up a list of titles from that supplier (sorted by default by popularity/rank and what you carry in your local inventory). Adding a title keyword will narrow down the search, where the title field here is not an exact match, but operates like the main Keyword search.<div className="shim" /><div className="shim" />

                    **Class | **Type or use <kbd>PgUp</kbd> to select either a main class, sub-class, or both. Only titles tagged with classes will return, so titles that have never been ordered or received will not appear in the results. If you leave the Title field blank, all titles matching the specified Class will list.
                </Label><div className="shim" />
                <div className="shim" /><div className="shim" />

                <Label style={{ "textAlign": "left" }}>
                    <strong style={{ "color": "var(--text-light)" }}>BISAC</strong><div className="shim" /><div className="shim" />
                    Enter the specific BISAC code (ex: SOC026030) to bring up titles with that same BISAC. You can enter just the main or secondary BISAC code (ex: SOC or SOC026) to bring up more titles within those broader groups.
                </Label><div className="shim" />
                <div className="shim" /><div className="shim" />

                <Label style={{ "textAlign": "left" }}>
                    <strong style={{ "color": "var(--text-light)" }}>UPC</strong><div className="shim" /><div className="shim" />
                    Exclusively searches the secondary UPC/ISBN field found on inventory records.
                </Label><div className="shim" />
                <div className="shim" /><div className="shim" />
                <Divider />
                <div className="shim" /><div className="shim" />

                <Label style={{ "textAlign": "left" }}>
                    The recommended method of search is via Titlelink (pressing Enter, PgUp or PgDn, or clicking the Search icon located within the search field). Titlelink searches our online database of millions of titles alongside your local inventory, then interweaves the two together to provide the most complete and comprehensive results. Our default search settings for Titlelink are to search both active (currently distributed) and inactive (out of print) titles, returning 100 results, and sorting the results by what you have on-hand and on-order first (sorting those by Rank/popularity), then showing high ranking/popular titles that you do not have on-hand or on-order, then finally showing un-ranked titles by release date (newest to oldest). This carefully tuned algorithm typically means what you are looking for is within the first 10-20 results, prioritizing your stock, but also bringing popular titles (both released and forthcoming) to the top as well. If you would like to change these defaults, and perhaps always show results sorted by Rank regardless of your stock levels, you can use  <kbd>Alt+S</kbd> to access the search Settings/Defaults menu, or click the Gear icon.<div className="shim" /><div className="shim" />
                    If you would only like to search your local inventory and not our complete database, use the Local Inventory button or press Ctrl+Enter when searching. Results will be sorted by your internal on-hand/on-order positions and internal sales history popularity. We find that local searching is helpful for the specific scenario where a customer is looking for titles of a specific genre or author, and they need something now (in-stock) so ordering is not an option. For example, a customer may ask "Can you show me all the books you have on kayaking? I need something today!" This is where doing a keyword search of KAYAK limited to your local inventory instead of the default Titlelink search will produce a list of titles that you have on-hand that contain KAYAK.
                </Label>

            </div>
        });
    }


    // Draw
    return (
        <Spin style={{ "margin": "0px -10px" }} loading={loading}>
            
            <div style={{ "width": "712px", "padding": "0px 10px" }}>
                <div className="shim" /><div className="shim" /><div className="shim" /><div className="shim" />
                <Space height={25} size={10}>
                    <Label className={(index === 0) ? "selected" : ""} width={80}>Keywords</Label>
                    <Input search placeholder="Search by partial title, author, ISBN, inventory notes, tags, publisher, etc" autoselect onChange={(e) => setSearch({ ...search, "keywords": e })} onFocus={() => setIndex(0)} className={(index !== 0) ? "dim" : ""} ref={e => (refs.current[0] = e)} width={600} edit onSearch={() => kbdEvent(KBD.ENTER)} controlled value={search.keywords} />
                </Space>
                <div className="shim" /><div className="shim" />
                <Divider><Label><em>Exact Match Search</em></Label></Divider>
                <div className="shim" />
                <Space height={25} size={10}>
                    <Label className={(index === 1) ? "selected" : ""} width={80}>ISBN</Label>
                    <Input autoselect onChange={(e) => setSearch({ ...search, "isbn": e })} className={(index !== 1) ? "dim" : ""} onFocus={() => setIndex(1)} ref={e => (refs.current[1] = e)} placeholder="" width={150} edit value={search.isbn} />
                </Space>
                <div className="shim" /><div className="shim" />
                <Space height={25} size={10}>
                    <Label className={(index === 2) ? "selected" : ""} width={80}>Title</Label>
                    <Input autoselect onChange={(e) => setSearch({ ...search, "title": e })} className={(index !== 2) ? "dim" : ""} onFocus={() => setIndex(2)} ref={e => (refs.current[2] = e)} placeholder="" width={600} edit value={search.title} />
                </Space>
                <div className="shim" /><div className="shim" />
                <Space height={25} size={10}>
                    <Label className={(index === 3) ? "selected" : ""} width={80}>Author</Label>
                    <Input autoselect controlled onChange={(e) => setSearch({ ...search, "author": e })} className={(index !== 3) ? "dim" : ""} onFocus={() => setIndex(3)} ref={e => (refs.current[3] = e)} placeholder="" width={600} edit value={search.author} />
                </Space>
                <div className="shim" /><div className="shim" />
                <Divider><Label><em>Advanced</em></Label></Divider>
                <div className="shim" />
                <Space height={25} size={10}>
                    <Label className={(index === 4) ? "selected" : ""} width={80}>Supplier</Label>
                    <Input uppercase controlled autoselect onChange={(e) => setSearch({ ...search, "supplier": e })} className={(index !== 4) ? "dim" : ""} onFocus={() => setIndex(4)} ref={e => (refs.current[4] = e)} placeholder="" width={55} edit value={search.supplier} />
                    <Label className={(index === 5) ? "selected" : ""}>+ Title</Label>
                    <Input autoselect onChange={(e) => setSearch({ ...search, "supplier_title": e })} onFocus={() => setIndex(5)} className={(index !== 5) ? "dim" : ""} ref={e => (refs.current[5] = e)} placeholder="" width={474} edit value={search.supplier_title} />
                </Space>
                <div className="shim" /><div className="shim" />
                <div>
                    <Space height={25} size={10}>
                        <Label className={(index === 6) ? "selected" : ""} width={80}>Class</Label>
                        <CategorySelectorInput doubleclick={KBD.F4} autoselect onChange={(e) => setSearch({ ...search, "class": e })} route={route} className={(index !== 6) ? "dim" : ""} onFocus={() => setIndex(6)} ref={e => (refs.current[6] = e)} placeholder="" width={200} edit value={search.class} />
                        <Label className={(index === 7) ? "selected" : ""}> + Title</Label>
                        <Input autoselect onChange={(e) => setSearch({ ...search, "class_title": e })} onFocus={() => setIndex(7)} className={(index !== 7) ? "dim" : ""} ref={e => (refs.current[7] = e)} placeholder="" width={329} edit value={search.class_title} />
                    </Space>
                </div>
                <div className="shim" /><div className="shim" />

                <div>
                    <Space height={25} size={10}>
                        <Label className={(index === 8) ? "selected" : ""} width={80}>BISAC</Label>
                        <Input maxLength={9} controlled uppercase autoselect onChange={(e) => setSearch({ ...search, "subject": e })} className={(index !== 8) ? "dim" : ""} onFocus={() => setIndex(8)} ref={e => (refs.current[8] = e)} placeholder="" width={120} edit value={search.subject} />
                    </Space>
                </div>

                <div className="shim" /><div className="shim" />
                <Space height={25} size={10}>
                    <Label className={(index === 9) ? "selected" : ""} width={80}>UPC</Label>
                    <Input autoselect onChange={(e) => setSearch({ ...search, "upc": e })} className={(index !== 9) ? "dim" : ""} onFocus={() => setIndex(9)} ref={e => (refs.current[9] = e)} placeholder="" width={200} edit value={search.upc} />
                </Space>
                <div className="shim" /><div className="shim" /><div className="shim" /><div className="shim" /><div className="shim" /><div className="shim" />

                <div style={{ "backgroundColor": "var(--console-bg)", "margin": "-10px -10px", "borderTop": "2px solid var(--border-secondary)", "padding": "10px" }}>
                    <div className="shim" />
                    <Float>
                        <div style={{ "padding": "0px 10px" }}>
                            <Space size={15}>
                                <ToolTip text={
                                    <div style={{ "textAlign": "center" }}>Press Enter, PgUp or PgDn to perform this search. <br /> Searches both your local inventory along with <br />Bookmanager's large Titlelink database and <br />interweaves the two.</div>
                                }><Button disabled={(index === 6 || index === 7)} style={{ "width": "100px" }} onClick={() => kbdEvent(KBD.ENTER)} styled>{"Titlelink"}</Button></ToolTip>
                                <ToolTip text={
                                    <div style={{ "textAlign": "center" }}>Press Ctrl+Enter to perform this search. <br />This limited search only uses your local inventory records. <br />Titles that have never been ordered or received by your <br />store will not appear.</div>
                                }><Button disabled={(index === 8)} style={{ "width": "140px" }} onClick={() => kbdEvent(KBD.CTRL_ENTER)} styled>{"Local Inventory"}</Button></ToolTip>
                            </Space>
                        </div>
                        <div style={{ "padding": "0px 10px" }}>
                            <Space size={15}>
                                <a onClick={() => drawHelp()}><Space size={5}><HelpIcon /><strong><small><em>Help</em></small></strong></Space></a>
                                <ToolTip text={
                                    <div style={{ "textAlign": "center" }}>Press Alt+S to access and modify<br /> searching default settings.</div>
                                }><a onClick={() => showSettings()}><Space size={5}><SettingsIcon /><strong><small><em>Settings / Default </em></small></strong></Space></a></ToolTip>
                            </Space>
                        </div>
                    </Float>
                    <div className="shim" /><div className="shim" /><div className="shim" />
                    <Status><InfoIcon /> {status[index]}</Status>
                </div>


            </div>
        </Spin>
    )
}